import { render } from "./conceptTest.vue?vue&type=template&id=fca46cac&scoped=true"
import script from "./conceptTest.vue?vue&type=script&lang=js"
export * from "./conceptTest.vue?vue&type=script&lang=js"

import "./conceptTest.vue?vue&type=style&index=0&id=fca46cac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fca46cac"

export default script